import BiForm from "@app/containers/BiForm";

const Home = ({ parameters }) => <BiForm parameters={parameters} />;

export default Home;

export async function getServerSideProps(context) {
  const { query } = context;

  // Query params can arrive double-encoded (e.g. ?formid%3D...%26tenantId%3D...): the whole encoded
  // string becomes a single key with an empty value. This happens both when it is the sole key AND when
  // other real params are appended (e.g. bi-main adds &sessionid=...&mode=tabular). Flatten per-key: any
  // key that itself looks like an encoded query ("formid=...&tenantId=...") is re-parsed and merged, so
  // `formid` etc. are recovered regardless of the surrounding params.
  const parameters: Record<string, string> = {};
  Object.entries(query).forEach(([key, value]) => {
    const val = Array.isArray(value) ? value[0] : value;
    if ((val === "" || val === undefined) && key.includes("=")) {
      new URLSearchParams(key).forEach((paramValue, paramKey) => {
        parameters[paramKey] = paramValue;
      });
    } else {
      parameters[key] = val as string;
    }
  });

  return {
    props: {
      parameters
    }
  };
}
